export enum TrackerEffectServeCodes {
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
}
